import { render, staticRenderFns } from "./IconCodeSnippetSvg.vue?vue&type=template&id=14508186"
import script from "./IconCodeSnippetSvg.vue?vue&type=script&lang=js"
export * from "./IconCodeSnippetSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports